export default "/images/28e94dba6ca3516bc5d8e3f346599db9.avif";